import axios from 'axios'
import config from '@/request/axiosBaseConfig'

const configApi = axios.create(config)

export default configApi
